import { render, staticRenderFns } from "./FontIcon.vue?vue&type=template&id=2745ae88&scoped=true"
import script from "./FontIcon.vue?vue&type=script&lang=js"
export * from "./FontIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2745ae88",
  null
  
)

export default component.exports